export default __webpack_public_path__ + "static/media/166.8c4f246f.jpg";